export const modeLabel = (mode) => {
  const labels = {
    structured_form: 'Structured Form',
    upload_only: 'Upload Only',
    external_artifact: 'External Artifact',
    hybrid: 'Hybrid',
  };
  return labels[mode] || String(mode || 'Unknown').replace(/_/g, ' ');
};

export const groupCatalogByInputMode = (items = []) => items.reduce((acc, item) => {
  const key = item.inputMode || 'unknown';
  if (!acc[key]) acc[key] = [];
  acc[key].push(item);
  return acc;
}, {});

export const modeTone = (mode) => {
  if (mode === 'structured_form') return 'primary';
  if (mode === 'upload_only') return 'warning';
  if (mode === 'external_artifact') return 'secondary';
  if (mode === 'hybrid') return 'success';
  return 'light';
};
